// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1i0gn","messages":"Chat_messages__2IYKq","dateDivider":"Chat_dateDivider__AYPu1"};